import React from 'react';
import PropTypes from 'prop-types';

import {Button, Input} from '../ui-components';
import Copyright from '../copyright/copyright';
import ModuleHeader from '../module-header/module-header';

import useWindowSize from '../../hooks/useWindowSize';
import {changeInputHandler, validateField} from '../../utils';
import {
  DESKTOP_WIDTH,
  EMAIL_REGEX,
  ErrorText,
  LoginText,
  Title,
} from '../../constants';

import './login.scss';

const Login = ({
  authData,
  handleForgotPasswordButtonClick,
  handleSignInButtonClick,
  isFormError,
  removeFormError,
  setAuthData,
}) => {
  const {
    userEmail,
    userEmailError,
    userEmailErrorMsg,
    userPassword,
    userPasswordError,
    userPasswordErrorMsg,
  } = authData;
  const windowSize = useWindowSize();
  const loginTitle = windowSize.width < DESKTOP_WIDTH ? Title.MOBILE : Title.DESKTOP;
  const loginText = windowSize.width < DESKTOP_WIDTH ? LoginText.MOBILE : LoginText.DESKTOP;

  const checkFormFailure = () => (
    !userEmail
    || userEmailError
    || !userPassword
    || userPasswordError
    || !EMAIL_REGEX.test(userEmail)
  );

  return (
    <div className='login'>
      <div className='login__wrapper'>
        <ModuleHeader
          error={isFormError}
          text={isFormError ? ErrorText.FAILED_AUTH : loginText}
          title={loginTitle}
          withMobileLogo
        />
        <form className='login__form'>
          <Input
            id='userEmail'
            errorMsg={userEmailErrorMsg}
            invalid={userEmailError}
            label='E-mail address'
            onBlur={(evt) => {
              validateField(
                evt,
                authData,
                setAuthData,
                (value) => EMAIL_REGEX.test(value),
                ErrorText.EMAIL_FORMAT_INVALID_ERROR,
                true,
              );
            }}
            onChange={(evt) => {
              changeInputHandler(evt, authData, setAuthData);
              removeFormError();
            }}
            value={userEmail}
          />
          <Input
            id='userPassword'
            errorMsg={userPasswordErrorMsg}
            invalid={userPasswordError}
            label='Password'
            onBlur={(evt) => {
              validateField(
                evt,
                authData,
                setAuthData,
                (value) => value.length > 0,
                '',
                true,
              );
            }}
            onChange={(evt) => {
              changeInputHandler(evt, authData, setAuthData);
              removeFormError();
            }}
            type='password'
            value={userPassword}
          />
          <Button
            classNameCustom='login__reset'
            onClick={handleForgotPasswordButtonClick}
            text='Forgot your password?'
          />
          <Button
            classNameCustom='login__submit-btn button_rectangle button_bg'
            disabled={checkFormFailure()}
            onClick={() => handleSignInButtonClick(userEmail, userPassword)}
            text='Sign in'
          />
        </form>
      </div>
      <Copyright />
    </div>
  );
};

Login.defaultProps = {
  isFormError: false,
  removeFormError: () => {},
};

Login.propTypes = {
  handleForgotPasswordButtonClick: PropTypes.func.isRequired,
  handleSignInButtonClick: PropTypes.func.isRequired,
  isFormError: PropTypes.bool,
  removeFormError: PropTypes.func,
};

export default Login;
